import { useEffect } from "react";

// Injects a JSON-LD <script> into <head> and cleans up on unmount.
export function JsonLd({ data, id }) {
  useEffect(() => {
    if (!data) return;
    const el = document.createElement("script");
    el.type = "application/ld+json";
    if (id) el.id = id;
    el.text = JSON.stringify(data);
    document.head.appendChild(el);
    return () => { document.head.removeChild(el); };
  }, [data, id]);
  return null;
}
